import React from 'react';
import { Button } from '../ui/button';
import { Phone, MessageCircle } from 'lucide-react';

const MobileMenu = ({ navLinks, onNavigate, onCall, onWhatsApp }) => (
  <div className="lg:hidden mt-4 pb-4 border-t border-slate-800">
    <nav className="flex flex-col gap-3 mt-4">
      {navLinks.map((link) => (
        <button
          key={link.id}
          onClick={() => onNavigate(link.id)}
          className="text-left text-slate-300 hover:text-white font-medium py-2 transition-colors"
        >
          {link.label}
        </button>
      ))}
      <div className="flex flex-col gap-2 mt-2">
        <Button
          onClick={onCall}
          variant="outline"
          className="border-2 border-blue-500/50 text-blue-400 hover:bg-blue-500/10 w-full"
          data-testid="mobile-call-btn"
        >
          <Phone className="w-4 h-4 mr-2" />
          Anrufen
        </Button>
        <Button
          onClick={onWhatsApp}
          className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white w-full"
          data-testid="mobile-whatsapp-btn"
        >
          <MessageCircle className="w-4 h-4 mr-2" />
          WhatsApp
        </Button>
      </div>
    </nav>
  </div>
);

export default MobileMenu;
